"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * tlPercentInput
 *
 * PAr défaut un % positif
 * supporte les attributs : allow-negative et max-decimals de input-type-number
 */
ngModule.directive("tlPercentInput", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: '' + '<div tl-input-wrapper>' + '   <input input-type-number/>' + '   <i class="input-icon percent-icon">%</i> ' + '</div>',
    priority: 1000,
    link: function link($scope, $el, $attrs) {
      $el.addClass("tl-percent-input-wrapper");
      if ($attrs.allowNegative) {
        $el.find('input').attr('allow-negative', 'true');
      }
      if ($attrs.maxDecimals) {
        $el.find('input').attr('max-decimals', $attrs['maxDecimals']);
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/inputs/tl-percent-input.js
// module id = 2976
// module chunks = 13